class ProductCard extends HTMLElement {
	static UNAVAILABLE_CLASS = 'product-card--unavailable';
	constructor() {
		super();
		this.elements = {
			badges: this.querySelector('.badges__container'),
			button: this.querySelector('button[name="add"]'),
			comparePrice: this.querySelector('.price--compare'),
			form: this.querySelector('form'),
			image: this.querySelector('.product-card__medium.product-card__medium--primary'),
			links: this.querySelectorAll('.product-card__link'),
			price: this.querySelector('.product-card__price .price'),
			priceWithCode: this.querySelector('.product-card__price-with-code'),
			selected_variant: this.querySelector('.product-card__selected-variant'),
		};
		// TODO: Implement default image selection
		//this.imageUrl = this.querySelector('.product-card__variant-radio:checked')?.dataset.image;
		this.imageUrl = this.querySelector('.quick-add__option--selected')?.dataset.image;
		this.addEventListener('change', this.handleChange.bind(this));
		this.elements.form?.addEventListener('submit', this.handleSubmit.bind(this));
	}
	getConfig() {
		const config = fetchConfig('javascript');
		delete config.headers['Content-Type'];
		config.headers['X-Requested-With'] = 'XMLHttpRequest';
		config.body = new FormData(this.elements.form);
		return config;
	}
	handleChange(event) {
		if (!event) return;
		this.setVariant(event.currentTarget);
	}
	handleError(response) {
		// TODO: Implement error handling
		console.log('handleError()', response);
	}
	handleResponse(response) {
		if (!response) return;
		const cartItems = document.querySelector('cart-items');
		const cartDrawer = document.querySelector('#DrawerCart');
		if (cartItems && cartDrawer) {
			cartItems.rerenderFromFetch(response);
			cartDrawer.open();
		} else {
			window.location = routes.cart_url;
		}
	}
	handleSubmit(event) {
		event.preventDefault();
		const config = this.getConfig();
		this.setButtonLoadingState(true);
		fetch(`${routes.cart_add_url}`, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					this.handleError(response);
				} else {
					this.handleResponse(response);
				}
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				this.setButtonLoadingState(false);
			});
	}
	setButtonState(isEnabled = true) {
		this.elements.button.disabled = !isEnabled;
	}
	setButtonLoadingState(isLoading = true) {
		const { button } = this.elements;
		this.setButtonState(!isLoading);
		isLoading ? button.classList.add('loading') : button.classList.remove('loading');
	}
	setVariant(option) {
		if (!option) return;
		const { available, comparePrice, image, price, url, variant } = option.dataset;
		const is_available = available === 'true';
		is_available
			? this.classList.remove(ProductCard.UNAVAILABLE_CLASS)
			: this.classList.add(ProductCard.UNAVAILABLE_CLASS);
		this.setButtonState(is_available);
		this.updateSelected(variant);
		this.updateLinks(url);
		this.updatePrice(price, comparePrice);
		this.updateImage(image);
		this.updateDynamicElements(url);
	}
	updateDynamicElements(url) {
		fetch(url)
			.then((response) => response.text())
			.then((html) => {
				const { badges, priceWithCode, price } = this.elements;
				const parser = new DOMParser();
				const parsedHTML = parser.parseFromString(html, 'text/html');
				const newBadges = parsedHTML.querySelector('.product .badges__container');
				const newPriceWithCode = parsedHTML.querySelector('.price-with-code');
				const newPrice = parsedHTML.querySelector('.product__price .price');
				if (badges != null && newBadges != null) {
					badges.innerHTML = newBadges.innerHTML;
				}
				if (priceWithCode != null) {
					priceWithCode.innerHTML = newPriceWithCode ? newPriceWithCode.outerHTML : '';
				}
				if (price != null) {
					price.innerHTML = newPrice.innerHTML;
				}
				// TODO: Implement caching?
			});
	}
	updateImage(url) {
		if (!url) {
			return;
		}
		const { image } = this.elements;
		const { src, srcset } = image;
		image.src = src.replace(this.imageUrl, url);
		image.srcset = srcset.replaceAll(this.imageUrl, url);
		this.imageUrl = url;
	}
	updateLinks(url) {
		this.elements.links.forEach((link) => {
			link.href = url;
		});
	}
	updatePrice(price, comparePrice) {
		this.elements.price.innerText = price;
		if (this.elements.comparePrice != null) {
			this.elements.comparePrice.innerText = comparePrice ? comparePrice : '';
		}
	}
	updateSelected(variantName) {
		const { selected_variant } = this.elements;
		if (!selected_variant) return;
		selected_variant.innerText = variantName;
	}
}
if (!customElements.get('product-card')) {
	customElements.define('product-card', ProductCard);
}
